<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    flatPickr,
  },

  inheritAttrs: false,

  model: {
    event: 'update',
  },

  props: {
    prepend: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'MM/DD/YYYY',
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['date'].includes(value)
      },
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'single'
    }
  },
  data: () => ({
    date: '',
    maximumDate: null,
    minimumDate: null,
  }),

  computed: {
    config() {
      return {
        allowInput: true,
        dateFormat: 'm/d/Y',
        maxDate: this.max,
        minDate: this.min,
        mode: this.mode
      }
    },
  },

  methods: {
    isFutureDate(date) {
      const currentDate = new Date()
      return date > currentDate
    },
  },
}
</script>
<template>
  <div>
    <flat-pickr
      :id="fieldId"
      v-bind="$attrs"
      :placeholder="placeholder"
      :config="config"
      :disabled="disabled"
      class="form-control"
      v-on="$listeners"
      @input="$emit('update', $event)"
    />
  </div>
</template>
